import InviteCastModal from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/cast-and-crew/cast-and-crew-select-with-invites/components/invite-cast-modal/invite-cast-modal';
import { useAppDispatch } from '@/store/hooks';
import { updateSpeaker } from '@/store/slices/speakers';
import { Speaker } from '@/types/speakers.types';
import { memo, useCallback } from 'react';

type TEditCastMemberProps = {
  editSpeaker: Speaker | null;
  setEditSpeaker: (speaker: Speaker | null) => void;
  defaultLang: string;
  languages: string[];
};

const EditCastMember = memo(({ editSpeaker, languages, defaultLang, setEditSpeaker }: TEditCastMemberProps) => {
  const dispatch = useAppDispatch();

  const handleEditCastMember = useCallback(
    (speaker: Speaker) => {
      if (!editSpeaker || editSpeaker.speaker !== speaker.speaker) {
        return;
      }

      dispatch(
        updateSpeaker({
          originalSpeaker: editSpeaker,
          speaker,
          baseLanguage: defaultLang,
          languages,
        })
      );

      setEditSpeaker(null);
    },
    [defaultLang, dispatch, editSpeaker, languages, setEditSpeaker]
  );

  return (
    <InviteCastModal
      open={!!editSpeaker}
      defaultSpeaker={editSpeaker}
      onClose={() => setEditSpeaker(null)}
      handleEditCast={handleEditCastMember}
    />
  );
});

EditCastMember.displayName = 'EditCastMember';

export default EditCastMember;
